import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../app.material.module';
import { RouterModule, Routes } from '@angular/router';
import { InfoPageComponent } from "./info-page.component";

const routes: Routes = [
  {
    path: ':page',
    component: InfoPageComponent
  }
];

@NgModule({
  declarations: [InfoPageComponent],
  imports: [CommonModule, MaterialModule, RouterModule.forChild(routes)],
  exports: [InfoPageComponent]
})
export class InfoPageModule {}
